import deckLog from '../utils/log';
import { getLoggers } from './loggers';
var loggers = {};

if (process.env.NODE_ENV !== 'production') {
  loggers = getLoggers(deckLog);
}

export function register(handlers) {
  loggers = handlers;
}
export default function debug(eventType) {
  if (deckLog.level > 0 && loggers[eventType]) {
    var _loggers$eventType;

    (_loggers$eventType = loggers[eventType]).call.apply(_loggers$eventType, arguments);
  }
}
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./~/@deck.gl/core/dist/esm/debug/index.js